import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

import { CreateDeckForm } from '@/features/deck-editor';

import styles from './NewDeckPage.module.css';

/** A page of its own for a new deck, like creating a repository on GitHub. */
export function NewDeckPage(): React.JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className={styles.page}>
      <div>
        <h1>{t('decks.newTitle')}</h1>
        <p className={styles.muted}>{t('decks.newLead')}</p>
      </div>
      <CreateDeckForm
        onCreated={(deck) => {
          void navigate(`/decks/${deck.id}`);
        }}
      />
    </div>
  );
}
